import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// The store uses `false` as an "empty" sentinel for several fields (a legacy
// convention preserved from the original JS reducer). Token also carries
// null/false when logged out — consumers normalize via useToken().
export interface User {
  id: string | false;
  role: string | false;
  isVerified: boolean;
  details: Record<string, unknown> | false;
  socketUUID: string | null | false;
  token: string | null | false;
  cert?: unknown;
}

interface KeyData {
  keyId: string | null;
  cert: unknown;
}

export interface UserState {
  user: User;
  keyId: string | null;
  cert: unknown;
  // Actions (replaces reducer actions).
  // setUser merges a partial identity into the current user so callers that
  // omit fields (e.g. AppWrapper's profile refresh, which does not resend
  // socketUUID) don't clobber them. removeUser is the explicit reset path.
  setUser: (user: Partial<User>) => void;
  setKey: (keyData: KeyData) => void;
  removeUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    set => ({
      user: {
        id: false,
        role: false,
        isVerified: false,
        details: false,
        socketUUID: null,
        token: null,
      },
      keyId: null,
      cert: undefined,

      setUser: user => set(state => ({ user: { ...state.user, ...user } })),
      setKey: keyData =>
        set({
          keyId: keyData.keyId,
          cert: keyData.cert,
        }),
      removeUser: () =>
        set({
          user: {
            id: false,
            role: false,
            isVerified: false,
            details: false,
            token: false,
            cert: false,
            socketUUID: false,
          },
          keyId: null,
          cert: undefined,
        }),
    }),
    {
      name: 'eximerp-user-session', // Descriptive localStorage key
    },
  ),
);
